import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { Header, Page } from 'components';
import { Card, CardContent } from '@mui/material';
import DataManagementForm from './components/DataManagementForm';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3)
	},
	content: {
		marginTop: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	}
}));

const DataManagement = () => {
	const classes = useStyles();

	return (
		<Page className={classes.root} title="Data Management">
			<Header module="Data" view="Management" />
			<Card className={classes.content}>
				<CardContent>
					<DataManagementForm />
				</CardContent>	
			</Card>		
		</Page>
	);
};

export default DataManagement;